import {createApp} from 'vue'
import StafetOpretHoldStepOne from './StafetOpretHoldStepOne'

const el = '.kb-component--stafet-opret-hold-step-one'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetOpretHoldStepOneDOM)=>{
            const component = createApp(StafetOpretHoldStepOne).use(Store)
            component.mount(StafetOpretHoldStepOneDOM)
        })
    }
}